import {
    AccountMappingAccountItem,
    AccountMappingTemplateGroupItem,
    IAccount,
    IAccountMappingSubFLI,
    IAccountMappingTemplateGroup,
    IAccountMappingTemplateGroupItemFLI,
    IAccountMappingTemplateGroupItemSubtotal,
} from '@modeso/types__aumico-lib-annualreport-be';
import { IAddSubFliEvent } from './IAddSubFliEvent.interface';
import { IAssignAccountEvent } from './IAssignAccountEvent.interface';
import { IRemoveAccountEvent } from './IRemoveAccountEvent.interface';
import { IAddFliEvent } from './add-fli-event.interface';
import { IAddSubtotalEvent } from './add-subtotal-event.interface';
import { ISplitAccountValues } from './split-account-values.interface';
import { IUncoveredShortfallSpecifications } from './uncovered-shortfall-specifications.interface';

export interface IGroupAccountMappingComponentDelegate {
    expandAll: boolean;
    collapseAll: boolean;
    templateGroup: IAccountMappingTemplateGroup;
    accountMappingMode: boolean;
    allFlis: IAccountMappingTemplateGroupItemFLI[];
    assignSelectedAccounts: (event: IAssignAccountEvent) => void;
    // used for subFlis as well
    removeAccounts: (event: IRemoveAccountEvent) => void;
    removeAccountFromFLI: (
        item: IAccountMappingTemplateGroupItemFLI,
        index: number,
        accountTopGroupName?: string,
    ) => void;
    removeAccountFromSubFLI: (item: IAccountMappingSubFLI, index: number, accountTopGroupName: string) => void;
    removeItemFromParentGroup: (item: AccountMappingTemplateGroupItem, removeAccounts: boolean) => void;
    removeGroup: (group: IAccountMappingTemplateGroup) => void;
    addSubFli: (event: IAddSubFliEvent) => void;
    addFli: (event: IAddFliEvent) => void;
    addSubtotalAfterIndex: (event: IAddSubtotalEvent) => void;
    addGroup: (parentGroup: IAccountMappingTemplateGroup, group: IAccountMappingTemplateGroup) => void;
    renameItem(item: IAccountMappingSubFLI, newCaption: string);
    renameGroup(group: IAccountMappingTemplateGroup, newTitle: string);
    updateFli: (
        updatedFli: IAccountMappingTemplateGroupItemFLI,
        oldFli: IAccountMappingTemplateGroupItemFLI,
        newParentGroup: IAccountMappingTemplateGroup,
        oldParentGroup: IAccountMappingTemplateGroup,
    ) => void;
    updateSubtotal: (
        updatedFli: IAccountMappingTemplateGroupItemSubtotal,
        oldFli: IAccountMappingTemplateGroupItemSubtotal,
        newIndex: number,
        oldIndex: number,
        oldParentGroup: IAccountMappingTemplateGroup,
    ) => void;
    addOrUpdateAccount: (
        oldAccount: IAccount | undefined,
        addedOrUpdatedAccounts: IAccount,
        item: IAccountMappingSubFLI | IAccountMappingTemplateGroupItemFLI,
        accountIndex: number,
    ) => void;
    getAddedAccountRowNumber: () => number;
    getFlisAndSubFlisForSwitchAccount: (
        initialTopGroupName: string,
    ) => (IAccountMappingSubFLI | IAccountMappingTemplateGroupItemFLI)[];
    getSplitAccountValues: (
        originalClosingValue: number,
        originalOpeningValue: number,
        topParentGroupName: string,
    ) => ISplitAccountValues;
    splitAccount: (
        account: IAccount,
        accountParentItem: IAccountMappingSubFLI | IAccountMappingTemplateGroupItemFLI,
        accountIndex: number,
        accountTopParentGroupName: string,
        splitParentItem: IAccountMappingSubFLI | IAccountMappingTemplateGroupItemFLI,
    ) => void;
    removeAccountByGroupName: (groupName: string, accountNumber: string) => void;
    getFlisAndSubFlisOfGroups: (
        group: IAccountMappingTemplateGroup,
    ) => (IAccountMappingSubFLI | IAccountMappingTemplateGroupItemFLI)[];
    getAllFlisInMappingTemplate: () => IAccountMappingTemplateGroupItemFLI[];
    getUncoveredShortfallSpecifications: () => IUncoveredShortfallSpecifications;
    applyUncoveredShortfall: (
        uncoveredShortfallAssetsFliCaption: string,
        uncoveredShortfallEquityFliCaption: string,
        uncoveredShortfallAssetsAccountName: string,
        uncoveredShortfallEquityAccountName: string,
    ) => void;
    reorderGroupItems: () => void;
    getItemIndexInsideGroup(item: AccountMappingTemplateGroupItem, parent: IAccountMappingTemplateGroup): number;
    getSubGroupIndexInsideGroup(item: IAccountMappingTemplateGroup, parent: IAccountMappingTemplateGroup): number;
    getItemIndexInsideSortedItems(
        item: IAccountMappingTemplateGroup | AccountMappingTemplateGroupItem,
        parent: IAccountMappingTemplateGroup,
    ): number;
    getSubfliOrOfThatItemIndexInsideFli(
        item: AccountMappingAccountItem,
        parent: IAccountMappingTemplateGroupItemFLI,
    ): number;

    getAccountIndexInsideFli(account: IAccount, parent: IAccountMappingTemplateGroupItemFLI): number;

    insertItemInItemsOfGroup(
        newItem: AccountMappingTemplateGroupItem,
        siblingItemIndex: number,
        parent: IAccountMappingTemplateGroup,
    ): void;
    insertItemInFli(
        newItem: AccountMappingAccountItem,
        siblingItemIndex: number,
        parent: IAccountMappingTemplateGroupItemFLI,
    ): void;
    insertItemInGroupsOfGroup(
        newItem: IAccountMappingTemplateGroup,
        siblingItemIndex: number,
        parent: IAccountMappingTemplateGroup,
    ): void;
    insertItemInSortedItems(
        newItem: IAccountMappingTemplateGroup | AccountMappingTemplateGroupItem,
        siblingItemIndex: number,
        parent: IAccountMappingTemplateGroup,
    ): void;
    getAllGroupsNamesToGroupsMap(): Map<string, IAccountMappingTemplateGroup>;
    getAccountTopGroupName(targetAccount: IAccount): string | undefined;
    getOfThatItemSiblings(ofThatItem: IAccountMappingSubFLI): IAccountMappingSubFLI[];
    cloneAccount(
        masterAccount: IAccount,
        masterParent: IAccountMappingSubFLI,
        targetOfThatItems: IAccountMappingSubFLI[],
        index: number,
    ): void;
}
